import { useEffect, useMemo, useState } from 'react'
// ui components
import { Input } from 'baseui/input';
import { Block } from 'baseui/block';
import { useStyletron } from 'baseui';
import { DatePicker } from "baseui/datepicker";
import { LoadingView } from '../../../components'
import { ViewSelector } from '../ViewSelector'
// api
import { useGetAllAlarmsQuery } from '../../../services/alarm'
import { VscFilter } from 'react-icons/vsc';
import { useIntl } from 'react-intl';
import { AlarmListItem } from '../AlarmListItem';
import { addMinutes, endOfDay, startOfDay } from 'date-fns';
import RenderIfVisible from 'react-render-if-visible';

export const AlarmJournalList = () => {
    const intl = useIntl();
    const [css, theme] = useStyletron();
    const [timeRange, setTimeRange] = useState([startOfDay(addMinutes(new Date(), -10000)), endOfDay(new Date())]);

    const { data, error, isLoading, isSuccess } = useGetAllAlarmsQuery({ timeFrom: timeRange[0].toISOString(), timeTo: timeRange[1].toISOString() });
    const [search, setSearch] = useState("");
    const onSearchChanged = (e: any) => setSearch(e.target.value);

    const filteredData = useMemo(() => {
        return data?.filter((a) => a.object.description?.includes(search)) ?? []
    }, [data, search])


    return (
        <>
            <Block display='flex' gridGap='20px' flexDirection='row' alignItems='center' >
                <Input
                    startEnhancer={<VscFilter />}
                    placeholder={intl.formatMessage({ id: `filterByKeyword`, defaultMessage: "Filter by keyword" })}
                    onChange={onSearchChanged}
                />
                <DatePicker
                    value={timeRange}
                    onChange={({ date }) =>
                        setTimeRange(Array.isArray(date) ? date : [date])
                    }
                    quickSelect
                    range
                    timeSelectStart
                    timeSelectEnd
                />
                <ViewSelector></ViewSelector>
            </Block>
            <div style={{ display: 'flex', marginTop: theme.sizing.scale500 }}>
                <div style={{ flex: '1 1 auto', height: '80vh' }}>
                    <LoadingView error={error} isLoading={isLoading} isSucess={isSuccess}>
                        {filteredData?.map((alarm, idnex) => (<>
                            <RenderIfVisible defaultHeight={100} visibleOffset={500} stayRendered>
                                <AlarmListItem count={0} alarms={[alarm]} key={alarm.id}></AlarmListItem>
                            </RenderIfVisible>
                        </>))}
                    </LoadingView>
                </div>
            </div>
        </>
    )




}
